import e from "./RelevantSort.vue_rollup-plugin-vue=script.js";
export default (function (e, t, n, r, s, i, a, l) {
  var o = ("function" == typeof n ? n.options : n) || {};
  return o.__file = "RelevantSort.vue", o.render || (o.render = e.render, o.staticRenderFns = e.staticRenderFns, o._compiled = !0, s && (o.functional = !0)), o._scopeId = r, o;
})({
  render: function render() {
    var e = this,
        t = e.$createElement,
        n = e._self._c || t;
    return e.state && e.state.isVirtualReplica ? n("div", {
      class: e.suit()
    }, [e._t("default", function () {
      return [n("div", {
        class: e.suit("text")
      }, [e._t("text", null, {
        isRelevantSorted: e.state.isRelevantSorted
      })], 2), e._v(" "), n("button", {
        class: e.suit("button"),
        attrs: {
          type: "button"
        },
        on: {
          click: function click(t) {
            return e.refine();
          }
        }
      }, [e._t("button", function () {
        return [e._v("\n        " + e._s(e.state.isRelevantSorted ? "See all results" : "See relevant results") + "\n      ")];
      }, {
        isRelevantSorted: e.state.isRelevantSorted
      })], 2)];
    }, {
      isRelevantSorted: e.state.isRelevantSorted,
      refine: e.state.refine
    })], 2) : e._e();
  },
  staticRenderFns: []
}, 0, e, void 0, !1);